import React, { useState, useEffect } from "react";
import axios from "axios";
import Box from "@mui/material/Box";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import PeopleIcon from "@mui/icons-material/People";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Link, useLocation } from "react-router-dom";
import Logo from "../../Assets/logo.jpg";
import GroupIcon from '@mui/icons-material/Group';
import SideBarNavBar from "../SideBarNavBar/SideBarNavBar";

export default function PatientSidebar() {
  const [state, setState] = useState({ left: false });
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submenuOpen, setSubmenuOpen] = useState({});
  const userDataString = localStorage.getItem("Login_User_Community_All_Data");
  const userData = userDataString ? JSON.parse(userDataString) : null;  
  // Check if user data exists
  const token = userData ? userData.token : null;
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  

  useEffect(() => {
    if (token) {
      fetchCategories();
    } else {
      console.error("No token found. Please login again.");
      // You could also redirect the user to login if no token
    }
  }, [token]); // Dependency on token to refetch categories when token changes

  // Fetch categories from API
  // const fetchCategories = async () => {
  //   try {
  //     setLoading(true);
  //     const roleId = userData ? userData.role : null;

  //     // Only make the API call if roleId and token are valid
  //     if (roleId && token) {
  //       const response = await axios.get(
  //         `http://localhost:8000/api/getCategoriesByRoleId/${roleId}`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${token}`, // Pass the token for authenticated API calls
  //           },
  //         }
  //       );
  //       setCategories(response.data);
  //     } else {
  //       console.error("Invalid role or token");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching categories:", error);
  //     setCategories([]);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const fetchCategories = async () => {
    try {
      setLoading(true);
      const roleId = userData ? userData.role : null;
      // Direct API call without token
      //const response = await axios.get("http://localhost:8000/api/getCategoriesByRoleId/${roleId}");
      const response = await axios.get(`${API_BASE_URL}/api/getCategoriesByRoleId/${roleId}`);

      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching categories:", error);
      setCategories([]);
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    fetchCategories();
  }, []); // Fetch categories on component mount
  

  const toggleDrawer = (open) => {
    setState({ ...state, left: open });
  };

  const toggleSubmenu = (key) => {
    setSubmenuOpen((prevState) => ({
      ...prevState,
      [key]: !prevState[key],
    }));
  };

  const list = () => {
    return (
      <Box
        sx={{
          width: 250,
          background: "#F4F8FB",
          height: "100%",
          overflowX: "hidden",
        }}
        role="presentation"
        onClick={() => toggleDrawer(false)}
        onKeyDown={() => toggleDrawer(false)}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 65,
          }}
        >
          <img
            src={Logo}
            alt="Inspire Community"
            style={{ maxWidth: "100%", maxHeight: 55 , width:"55%"}}
          />
        </Box>
        <Divider />
        <ListItem >
            <Link
              to={`/patient-user/patient-dashboard`}
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <ListItemText primary={"Dashboard"} />
            </Link>
          </ListItem>
                   
        <List>
          {loading ? (
            <ListItem>
              <ListItemText primary="Loading categories..." />
            </ListItem>
          ) : categories.length > 0 ? (
            categories.map((category) => (
              <div key={category.id}>
                <ListItem button onClick={() => toggleSubmenu(category.id)}>
                  <ListItemText primary={category.name} />
                  {submenuOpen[category.id] ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                {category.subcategories && category.subcategories.length > 0 && (
                  <Collapse in={submenuOpen[category.id]} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      {category.subcategories.map((subcategory) => (
                        <ListItem key={subcategory.id} sx={{ pl: 4 }}>
                          <Link
                            to={`/patient-user/sub-category/${subcategory.id}`}
                            style={{ textDecoration: "none", color: "inherit" }}
                          >
                            <ListItemText primary={subcategory.name} />
                          </Link>
                        </ListItem>
                      ))}
                    </List>
                  </Collapse>
                )}
              </div>
            ))
          ) : (
            <ListItem>
              <ListItemText primary="No categories available." />
            </ListItem>
          )}
        </List>
      </Box>
    );
  };

  return (
    <>
      <SideBarNavBar toggleDrawer={toggleDrawer}  />
      <div>
      
        <SwipeableDrawer
          anchor="left"
          open={state.left}
          onClose={() => toggleDrawer(false)}
          onOpen={() => toggleDrawer(true)}
        >
          {list()}
        </SwipeableDrawer>

        <Drawer
          variant="permanent"
          anchor="left"
          open
          sx={{
            "& .MuiDrawer-paper": {
              width: 250,
              boxSizing: "border-box",
              overflowX: "hidden",
            },
          }}
        >
          {list()}
        </Drawer>
      </div>
    </>
  );
};
